import React, { useState } from "react";
import { Container, Row, Col, Form, Button, Image } from "react-bootstrap";
// import axios from "axios";
import helloImage from "../../../assets/images/hello-img.jpg";
import phoneIcon from "../../../assets/images/icons/phone-icon.svg";
import emailIcon from "../../../assets/images/icons/email-icon.svg";
import locationIcon from "../../../assets/images/icons/location-icon.svg";
import Header from "../../header/Header";
import Footer from "../../footer/Footer";
import "./ContactUs.scss";

const ContactUs = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log(formData);

    // try {
    //   // Replace with your real endpoint
    //   const response = await axios.post(
    //     "https://your-api-url.com/contact",
    //     formData
    //   );
    //   toast.success("Message sent successfully!");
    //   setFormData({
    //     firstName: "",
    //     lastName: "",
    //     email: "",
    //     phone: "",
    //     message: "",
    //   });
    // } catch (error) {
    //   toast.error("Failed to send message. Please try again.");
    //   console.error("Form submit error:", error);
    // }
  };

  return (
    <>
      <Header />
      <div className="contact-us-page py-10 py-md-12">
        <Container className="py-md-6">
          <Row className="g-5 align-items-stretch">
            {/* Left: Contact Info */}
            <Col
              md={12}
              className="mb-5 mb-md-0 d-flex flex-column justify-content-center rounded-4 p-5 p-md-6"
            >
              <h1 className="mb-3 text-center text-primary text-xl-start">
                Contact Us
              </h1>
              <h5 className="fw-bold mb-3 text-center text-xl-start mt-5">
                Got a question? We’re just a message away.
              </h5>

              <p className="lead mb-5">
                Use the form, email us, or drop us a WhatsApp, whatever’s
                easiest. <br />
                And if you need help right now, click the chat bubble at the
                bottom right of this page or in the app.
              </p>
              <p className="lead mb-5">
                We’re here to support you, your family, or someone you care for.
              </p>
              <div className="contact-info-list d-flex flex-column gap-8 mt-5">
                <div className="d-flex align-items-center lead">
                  <span
                    className="contact-label fw-bold me-2"
                    // style={{ width: "120px" }}
                  >
                    <Image
                      width={24}
                      height={24}
                      src={phoneIcon}
                      className="img-fluid"
                      alt=""
                    />
                  </span>
                  <span>+44 7587 489564</span>
                </div>
                <div className="d-flex align-items-center lead">
                  <span
                    className="contact-label fw-bold me-2"
                    // style={{ width: "120px" }}
                  >
                    <Image
                      width={24}
                      height={24}
                      src={emailIcon}
                      className="img-fluid"
                      alt=""
                    />
                  </span>
                  <span>Support@Elderlylife.com</span>
                </div>
                <div className="d-flex align-items-start lead">
                  <span
                    className="contact-label fw-bold me-2"
                    // style={{ width: "120px" }}
                  >
                    <Image
                      width={24}
                      height={24}
                      src={locationIcon}
                      className="img-fluid"
                      alt=""
                    />
                  </span>
                  <span className="flex-grow-1">
                    Unit H, Gateway 1000 Whittle Way, Stevenage, England, SG1
                    2FP
                  </span>
                </div>
              </div>
            </Col>
            {/* Right: Contact Form */}
            <Col md={12} className="d-flex align-items-center">
              <div className="contact-form-wrapper w-100 p-4 p-md-5 rounded-4 shadow bg-white">
                <div className="text-center mb-4">
                  <Image
                    src={helloImage}
                    alt="Hello"
                    fluid
                    className="ms-2"
                    style={{
                      height: "auto",
                      maxWidth: "100%",
                      objectFit: "contain",
                    }}
                  />
                </div>
                {/* <Form onSubmit={handleSubmit}>
                  <Row className="mb-3">
                    <Col>
                      <Form.Group controlId="formFirstName">
                        <Form.Label>Name</Form.Label>
                        <Form.Control
                          type="text"
                          name="firstName"
                          placeholder="First"
                          value={formData.firstName}
                          onChange={handleChange}
                          required
                        />
                      </Form.Group>
                    </Col>
                    <Col>
                      <Form.Group controlId="formLastName">
                        <Form.Label className="invisible">Last</Form.Label>
                        <Form.Control
                          type="text"
                          name="lastName"
                          placeholder="Last"
                          value={formData.lastName}
                          onChange={handleChange}
                          required
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  
                  <Form.Group className="mb-3" controlId="formEmail">
                    <Form.Label>Email</Form.Label>
                    <Form.Control
                      type="email"
                      name="email"
                      placeholder="example@email.com"
                      value={formData.email}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>

                  <Form.Group className="mb-3" controlId="formPhone">
                    <Form.Label>Phone (optional)</Form.Label>
                    <Form.Control
                      type="text"
                      name="phone"
                      placeholder="xxx-xxx-xxxx"
                      value={formData.phone}
                      onChange={handleChange}
                    />
                  </Form.Group>

                  <Form.Group className="mb-4" controlId="formMessage">
                    <Form.Label>Message</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={4}
                      name="message"
                      placeholder="Type your message ..."
                      value={formData.message}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>

                  <div className="d-grid">
                    <Button
                      className="btn btn-primary btn-lg"
                      type="submit"
                      style={{ border: "none" }}
                    >
                      Submit
                    </Button>
                  </div>
                </Form> */}
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      <Footer />
    </>
  );
};

export default ContactUs;
